"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.applyMiddlewares = applyMiddlewares;
function applyMiddlewares() {
    for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
        middlewares[_key] = arguments[_key];
    }

    let compiled = middlewares.reduceRight((next, current) => {
        return function* (param, last) {
            yield* current(param, function* (additional) {
                yield* next(param, last);
            });
        };
    }, function* (param) {
        let last = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

        yield* last(param, noop);
    });
    return compiled;
}
function* noop(param, next) {}
//# sourceMappingURL=applyMiddlewares.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/utils/applyMiddlewares.js